module.exports = __webpack_public_path__ + "static/media/macbook-hand.ff1e7735.png";